import React from 'react'
import { useTranslation } from 'react-i18next'

import NavigationBar from '../components/NavigationBar'
import Footer from '../components/Footer/Footer'
import PageHeroTitle from '../components/PageHeroTitle'
import BottomImage from '../components/BottomImage'

function PageNotFound() {
  const { t } = useTranslation()
  const pageName = 'PAGE_NOT_FOUND'

  return (
    <div>
      <NavigationBar />

      <PageHeroTitle
        title={t(`${pageName}_TITLE`)}
        description={t(`${pageName}_DESCRIPTION`)}
      />

      <div className="p-3">
        <p>{t(`${pageName}_MESSAGE`)}</p>
      </div>

      <BottomImage name={pageName} />

      <Footer />
    </div>
  )
}

export default PageNotFound
